import React, { Component } from 'react';
import {
  setDefaultChannel,
  getDefaultChannel,
  getIssues,
  getProject,
  getBotChannel,
  logOutSkillUser,
  // addUserBasicToken,
  deleteUserConfig,
  getSkillUser,
  getJiraBoards,
  deleteDefaultChannel,
  getServiceDeskProject,
  deleteChannelConfigurations,
  getCommonData,
  getUserMappingAndUsers,
  checkJiraTokenValidity,
} from '../skills_action';
import { connect } from 'react-redux';
import moment from 'moment';
import JiraPersonalNotification from './presonal_notification';
import CreationDefault from './personal_preference/creationDefault.js';
import TeamMemberPreference from './personal_preference/team_member_preferences.js';
import IssueCardCustomizationInfo from './IssueCardCustomization/IssueCardFieldCustomizationInfo';
import MultiTaskIt from './multi_task_It';
import { withRouter } from 'react-router-dom';
import { SettingOutlined } from '@ant-design/icons';

import './personal_preferences.css';
import {
  Button,
  Select,
  Dropdown,
  Menu,
  Modal,
  Card,
  message,
  Row,
  Col,
  Layout,
  Typography,
  Collapse,
  Switch,
  PageHeader,
  Tabs,
  Popconfirm,
  Alert,
  Anchor,
} from 'antd';
import '../jira/jira.css';
import JiraServerModal from './jira_server_modal';
import { getOauthTokensForUsers } from '../../jiraoauth/jiraoauth.action';
import { getOauthTokensForCloudUsers } from '../../jiraoauth/jiraOAuthCloud.action';

import axios from 'axios';
const { Option } = Select;
const { Content } = Layout;
const { Panel } = Collapse;
const { Link } = Anchor;
const { Text, Paragraph } = Typography;
const { TabPane } = Tabs;
const setFieldValueValues = [
  {
    label: 'Parent',
    value: 'parent',
  },
  {
    label: 'Components',
    value: 'components',
  },
  {
    label: 'Sprint',
    value: 'sprint',
  },
  {
    label: 'Fix versions',
    value: 'fix_versions',
  },
  {
    label: 'Priority',
    value: 'priority',
  },
  {
    label: 'Team',
    value: 'team',
  },
  {
    label: 'Labels',
    value: 'labels',
  },
  {
    label: 'Test Team',
    value: 'test_team',
  },
  {
    label: 'Assignee',
    value: 'assignee',
  },
];

class JiraPersonalPreference extends Component {
  defaultState = {
    loading: false,
    channels: [],
    projects: [],
    issues: [],

    defaultProject: '',
    defaultIssue: '',
    skillsToggle: false,
    notificationToggle: false,
    personalNotifToggle: false,
    selectedChannel: '',
    selectedProject: '',
    edit: false,
    error: {},
    unlinkJiraAccount: false,
    dropdownOpen: false,
    setFieldValueField: '',
    setFieldInputField: '',
    defaultloading: false,
    newConnectionModal: false,
    board: '',
    boardData: [],
    isThreadSync: false,

    //jsd
    jsd_edit: false,
    selectedJsdProject: '',
    selectedJsdRequestType: '',
    create_tickets_by_default: false,
    preference: 'channel',
    showIssueCardCustomizationModal: false,
    personalNotifConfig: {},
  };

  constructor(props) {

    super(props);
    this.formRef = React.createRef();
    this.state = {
      ...this.defaultState,
      selectedMember: false,

      tab: '1',
      currentSkill: this.props.match.params.skill_id,
      personalChannelId: '',
      personalConnected: false,
    };
    this.debounceTimer = null;

    // this.openEditState = this.openEditState.bind(this);
  }

  componentDidMount() {
    let UserID = localStorage.trooprUserId;
    this.props
      .getSkillUser(
        this.props.match.params.wId,
        this.props.match.params.skill_id
      )
      .then((res) => {
        if (
          res.data.skillUser &&
          res.data.skillUser.token_obj &&
          res.data.skillUser.token_obj.access_token
        ) {
          this.setState({ personalConnected: true });
        }
      });
    this.setState({ loading: true, jsd_loading: true });
    let skillId = this.props.match.params.skill_id;
    if (this.props.isFromCheckins) {
    } else {
      if (this.props.skillView.tab === 'team_pref') {
        this.setState({ tab: '2' });

        this.setState({ personalChannelId: null });
        this.props.getUserMappingAndUsers(
          this.props.workspace_id,
          this.props.skill._id,
          false,
          '.',
          true
        );
      } else {
        this.props
          .getBotChannel(this.props.workspace_id, UserID)
          .then((res) => {
            if (res.data.success) {
              this.setState({ personalChannelId: res.data.channel.id });
              this.getCommonData(res.data.channel.id);
            }
          });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.sub_skill !== this.props.match.params.sub_skill)
      if (this.props.scrollContentRef && this.props.scrollContentRef.current)
        this.props.scrollContentRef.current.scrollTo(0, 0);
  }

  getCommonData = (channel_id) => {
    const { team } = this.props;
    if (!channel_id) channel_id = this.state.personalChannelId;
    const isGridWorkspace =
      team.bot &&
        team.bot.meta &&
        team.bot.meta.enterprise &&
        team.bot.meta.enterprise.id
        ? true
        : false;
    this.props
      .getCommonData(
        this.props.match.params.wId,
        this.props.match.params.skill_id,
        this.props.isWorkspaceAdmin,
        isGridWorkspace,
        [channel_id],
        false,
        true /* is personalPref */
      )
      .then((res) => {
        if (res.success) {
          let data = res.commonData && res.commonData[0];
          if (data) {
            this.setState({ isThreadSync: data.isThreadSync });
          }
        }
      });
  };

  goToUserJiraLogin = async (servertype) => {
    if (servertype && servertype === 'jira_server_oauth') {
      let url = await getOauthTokensForUsers(
        this.props.match.params.wId,
        this.props.match.params.sub_skill
      );
      if (!url) {
        message.error(
          'Error Logging in make sure you connected to jira or disconnect and try connection jira again'
        );
      } else {
        window.open(url, '_blank');
      }
    } else if (servertype && servertype === 'jira_cloud_oauth') {
      let url = await getOauthTokensForCloudUsers(
        this.props.match.params.wId,
        this.props.match.params.sub_skill
      );
      if (!url) {
        message.error(
          'Error Logging in make sure you connected to jira or disconnect and try connection jira again'
        );
      } else {
        window.open(url, '_blank');
      }
    } else {
      const url = `/${this.props.match.params.wId}/jira_user_oauth/${this.props.match.params.skill_id}`;
      window.open(url, '_blank');
    }

    /*this.props.history.push("/workspace/"+this.props.workspace_id+"/jira_user_oauth/"+this.props.skill._id)*/
  };

  unlinkJiraAccountToggle = () => {
    this.setState({ unlinkJiraAccount: !this.state.unlinkJiraAccount });
  };

  logOutSkillUser() {
    this.props
      .logOutSkillUser(
        this.props.workspace_id,
        this.props.match.params.skill_id,
        this.props.currentSkillUser.user_id
      )
      .then((res) => {
        this.setState(
          { unlinkJiraAccount: !this.state.unlinkJiraAccount },
          () => {
            this.props
              .getSkillUser(
                this.props.match.params.wId,
                this.props.match.params.skill_id
              )
              .then((res) => {
                res.data.success && this.setState({ personalConnected: false });
              });
            this.props.deleteUserConfig(
              this.props.match.params.wId,
              this.props.match.params.skill_id,
              this.state.personalChannelId
            );
          }
        );
      });
  }

  onClickDelete = (type) => {
    const { deleteDefaultChannel, personalChannelDefault } = this.props;
    const { personalChannelId } = this.state;

    if (type === 'ticket_defaults') {
      if (personalChannelDefault.link_info.project_id) {
        let data = { ...personalChannelDefault };
        delete data.link_info.jira_service_desk;
        delete data.link_info.create_tickets_by_default;
        this.props
          .setDefaultChannel(
            this.props.match.params.wId,
            this.props.match.params.skill_id,
            data,
            this.state.preference
          )
          .then((res) => {
            if (res.data.success) {
              this.setState({
                selectedJsdProject: '',
                selectedJsdRequestType: '',
                create_tickets_by_default: false,
              });
              message.success('Issue defaults deleted successfully');
            }
          });
      } else this.deletePersonalDefaults();
    } else if (type === 'issue_defaults') {
      if (personalChannelDefault.link_info.jira_service_desk) {
        let data = { ...personalChannelDefault };

        data.link_info = {
          jira_service_desk: personalChannelDefault.link_info.jira_service_desk,
          create_tickets_by_default:
            personalChannelDefault.create_tickets_by_default || false,
        };

        this.props
          .setDefaultChannel(
            this.props.match.params.wId,
            this.props.match.params.skill_id,
            data,
            this.state.preference
          )
          .then((res) => {
            if (res.data.success) {
              this.setState({
                defaultProject: '',
                defaultIssue: '',
                board: '',
                linkedProjectName: '',
              });
              message.success('Request defaults deleted successfully');
            }
          });
      } else this.deletePersonalDefaults();
    }
  };

  deletePersonalDefaults = () => {
    const { deleteDefaultChannel } = this.props;
    const { personalChannelId } = this.state;

    this.setState({ defaultloading: true });
    deleteDefaultChannel(
      this.props.match.params.wId,
      this.props.match.params.skill_id,
      personalChannelId,
      'personal'
    ).then((res) => {
      if (res.success) {
        message.success('Persoanl defaults deleted successfully');
        this.getCommonData();
        this.setState({
          defaultProject: null,
          defaultIssue: null,
          board: '',
          linkedProjectName: '',
          selectedJsdProject: '',
          selectedJsdRequestType: '',
          create_tickets_by_default: false,
        });
      } else {
        message.error('Error deleting personal defaults');
      }
      this.setState({ defaultloading: true });
    });
  };

  menus = () => {
    const onVerifyConnectionClick = async () => {
      let skillId = this.props.match.params.skill_id;
      let workspaceId = this.props.match.params.wId;
      let userId = localStorage.trooprUserId;

      let resp = checkJiraTokenValidity({ userId, skillId, wId: workspaceId });
      resp.then((res) => {
        if (res.data.success) {
          Modal.success({
            title: 'Connection token is Valid',
          });
        } else {
          Modal.error({
            title: 'Connection token is NOT Valid',
          });
        }
      });
    };
    return (
      <Menu>
        {/* {this.props.currentSkill.metadata && (this.props.currentSkill.metadata.server_type != "jira_server"&&this.props.currentSkill.metadata.server_type != "jira_server_oauth") ?
          <Menu.Item onClick={this.goToUserJiraLogin}>
            Change Jira Account
        </Menu.Item>
          :this.props.currentSkill.metadata.server_type == "jira_server_oauth"? <Menu.Item onClick={()=>this.goToUserJiraLogin(this.props.currentSkill.metadata.server_type)}>
          Change Jira Account
      </Menu.Item>:
          <Menu.Item onClick={this.openConnectModal}>
            Change Jira Account
      </Menu.Item>
        } */}
        <Menu.Item onClick={this.unlinkJiraAccountToggle}>
          Unlink Jira Account
        </Menu.Item>
        <Menu.Item onClick={onVerifyConnectionClick}>
          Verify Connection
        </Menu.Item>
      </Menu>
    );
  };

  toggleSetFieldValue = () => {
    this.setState({ setFieldValueModal: !this.state.setFieldValueModal });
  };

  toggleSetFieldValueCancel = () => {
    this.setState({
      setFieldValueField: '',
      setFieldInputField: '',
      setFieldValueModal: !this.state.setFieldValueModal,
    });
  };

  toggleSetFieldValueOk = () => {
    this.setState({ setFieldValueModal: !this.state.setFieldValueModal });
  };

  setFieldFieldValue = (event) => {
    this.setState({ setFieldValueField: event });
  };

  setFieldInputValue = (event) => {
    this.setState({ setFieldInputField: event.target.value });
  };

  openConnectModal = () => {
    this.setState({ newConnectionModal: true });
  };

  handleCancel = () => {
    this.setState({ newConnectionModal: false });
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };


  threadSyncToggle = () => {
    let skill_id = this.props.match.params.skill_id;
    let channel_id = this.state.personalChannelId;
    let workspace_id = this.props.match.params.wId;
    // let link = `/bot/api/${workspace_id}/isThreadSync/${skill_id}/${channel_id}`;
    let link = `/bot/api/w/${workspace_id}/jira/isThreadSync/${skill_id}/${channel_id}`;

    let data = {
      isThreadSync: !this.state.isThreadSync,
    };
    axios
      .post(link, data)
      .then((data) => {
        data = data.data;
        if (data && data.commonChannelData) {
          this.setState({ isThreadSync: data.commonChannelData.isThreadSync });
        }
      })
      .catch((error) => {
        message.error('Some error occurred. Please try again.');
      });
  };

  handleCreate = async () => {
    // const { form } = this.formRef.props;
    try {
      const values = await this.formRef.current.validateFields()

      let currentWorkspaceId = localStorage.getItem('userCurrentWorkspaceId');
      this.props
        .addUserBasicToken(
          currentWorkspaceId,
          this.props.match.params.skill_id,
          {
            username: values.username,
            password: values.password,
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({ newConnectionModal: false });
            this.formRef.current.resetFields();
          } else {
            message.error('Credentials incorrect, Try again');
          }
        });
    } catch (_) {


    }
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };
  // Jira New Connection End

  getContent = ({ domainName, serverType, connectedAt }) => {
    const { currentSkillUser, skill } = this.props;
    return (skill && skill.skill_metadata
      ? skill.skill_metadata.linked
      : skill.linked) &&
      currentSkillUser &&
      currentSkillUser._id &&
      currentSkillUser.token_obj ? (
      currentSkillUser.token_obj.type === 'Guest' ? (
        <Card
          size='small'
          title='My Account'
          extra={
            <Button onClick={this.goToUserJiraLogin}>Link Jira Account</Button>
          }
        >
          <p>
            You are connected as a guest User. The domain is '{domainName}' and
            you are connected as '{currentSkillUser.user_obj.emailAddress}'.
          </p>
        </Card>
      ) : (
        <div>
          <Card
            title='My Account'
            style={{ height: '100%' }}
            extra={
              <Dropdown overlay={this.menus()} trigger={['hover']}>
                <Button type='link' icon={<SettingOutlined />} />
              </Dropdown>
            }
          >
            {this.props.currentSkillUser.skill_id &&
              serverType != 'jira_server' &&
              serverType !== 'jira_server_oauth' &&
              serverType !== 'jira_cloud_oauth' ? (
              <div>
                <Text type='secondary'>Connected to: </Text>
                {domainName}
                <br />
                <Text type='secondary'>Connected at: </Text>
                {connectedAt}
                <br />
                <Text type='secondary'>Connected as: </Text>
                {currentSkillUser.user_obj &&
                  currentSkillUser.user_obj.emailAddress}
                {/* Connected to Jira domain '{domainName}' as '
                  {currentSkillUser.user_obj && currentSkillUser.user_obj.emailAddress}' {connectedAt}. */}
              </div>
            ) : (
              <div>
                <Text type='secondary'>Connected to: </Text>
                {this.props.currentSkillUser.skill_id &&
                  this.props.currentSkillUser.skill_id.metadata &&
                  this.props.currentSkillUser.skill_id.metadata.domain_url}
                <br />
                <Text type='secondary'>Connected at: </Text>
                {connectedAt}
                <br />
                <Text type='secondary'>Connected as: </Text>
                {currentSkillUser.user_obj &&
                  currentSkillUser.user_obj.emailAddress
                  ? currentSkillUser.user_obj.emailAddress
                  : currentSkillUser.user_obj &&
                    currentSkillUser.user_obj.displayName
                    ? currentSkillUser.user_obj.displayName
                    : currentSkillUser.user_obj.name
                      ? currentSkillUser.user_obj.name
                      : ''}
                {/* Connected to Jira domain '{this.props.currentSkillUser.skill_id && this.props.currentSkillUser.skill_id.metadata && this.props.currentSkillUser.skill_id.metadata.domain_url}' as '
                {currentSkillUser.user_obj && currentSkillUser.user_obj.emailAddress ? currentSkillUser.user_obj.emailAddress : currentSkillUser.user_obj && currentSkillUser.user_obj.name ? currentSkillUser.user_obj.name : ''}' {connectedAt}. */}
              </div>
            )}
          </Card>
        </div>
      )
    ) : (
      <>
        <Card
          title='My Account'
          extra={
            this.props.currentSkill.skill_metadata ? (
              <div>
                {this.props.currentSkill.skill_metadata.metadata.server_type ==
                  'jira_server' ? (
                  <Button type='Primary' onClick={this.openConnectModal}>
                    Login to Verify
                  </Button>
                ) : (
                  <Button
                    type='Primary'
                    onClick={() => {
                      this.goToUserJiraLogin(
                        this.props.currentSkill.skill_metadata.metadata
                          .server_type
                      );
                    }}
                  >
                    Login to Verify
                  </Button>
                )}{' '}
              </div>
            ) : (
              <div>
                {this.props.currentSkill.metadata &&
                  this.props.currentSkill.metadata.server_type ==
                  'jira_server' ? (
                  <Button type='Primary' onClick={this.openConnectModal}>
                    Login to Verify
                  </Button>
                ) : (
                  <Button
                    type='Primary'
                    onClick={() => {
                      this.goToUserJiraLogin(
                        this.props.currentSkill.metadata.server_type
                      );
                    }}
                  >
                    Login to Verify
                  </Button>
                )}
              </div>
            )
          }
        >
          <p>
            {currentSkillUser.user_obj && currentSkillUser.user_obj.displayName
              ? 'Your account is mapped to ' +
              currentSkillUser.user_obj.displayName +
              `${currentSkillUser.user_obj.emailAddress
                ? ` (${currentSkillUser.user_obj.emailAddress})`
                : ''
              }. Click "login to verify" to Verify Account`
              : `User account verification is necessary to attribute Jira ${this.props.match.params.sub_skill === 'jira_service_desk'
                ? 'request'
                : 'issue'
              } actions taken in Slack to the correct Jira user.`}
          </p>
        </Card>
      </>
    );
  };

  getModals = ({ currentSkillUser }) => {
    const sub_skill = this.props.match.params.sub_skill;
    let dynamicText = '';
    if (sub_skill === 'jira_software') {
      dynamicText = 'Helpdesk and Reports';
    } else if (sub_skill === 'jira_service_desk') {
      dynamicText = 'Projects and Reports';
    } else if (sub_skill === 'jira_reports') {
      dynamicText = 'Projects and Helpdesk';
    }
    return (
      <>
        <Modal
          visible={this.state.unlinkJiraAccount}
          onCancel={this.unlinkJiraAccountToggle}
          onOk={() => this.logOutSkillUser()}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <p>Are you sure you want to unlink the jira account</p>
            <p>
              '
              {currentSkillUser &&
                currentSkillUser._id &&
                currentSkillUser.user_obj &&
                currentSkillUser.user_obj.emailAddress
                ? currentSkillUser.user_obj.emailAddress
                : currentSkillUser &&
                  currentSkillUser._id &&
                  currentSkillUser.user_obj
                  ? currentSkillUser.user_obj.displayName
                  : ''}
              ' ,
              <br />
              Disconnecting the Jira personal connection will disconnect
              personal connection for {dynamicText} too,
              <br />
              Are you sure?
            </p>
          </div>
        </Modal>

        <JiraServerModal
          currentSkillUser={currentSkillUser}
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.newConnectionModal}
          onCancel={this.handleCancel}
          // onCreate={this.handleCreate}
          serverConnection={false}
        />
      </>
    );
  };

  selectMember = async (e, field) => {
    this.setState({ selectedMember: field });

    // sConfigMember={selectedMember.value} accountId={selectedMember.key}

    let res = await this.props.getBotChannel(
      this.props.workspace_id,
      field.value
    );
    if (res.data.success) {
      this.setState({ personalChannelId: res.data.channel.id });
      this.getCommonData(res.data.channel.id);
    }
  };
  create_tickets_by_default = (checked) => {
    let data = this.props.personalChannelDefault;
    if (data.link_info) {
      data.link_info.create_tickets_by_default = checked;
      this.props
        .setDefaultChannel(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          data,
          this.state.preference
        )
        .then((res) => {
          if (res.data.success)
            this.setState({ create_tickets_by_default: checked });
        });
    }
  };

  deletePersoanlConfigurations = () => {
    let data = {
      channel_id: this.state.personalChannelId,
      skill_id: this.props.match.params.skill_id,
    };

    this.props
      .deleteChannelConfigurations(
        this.props.match.params.wId,
        data,
        'personal'
      )
      .then((res) => {
        if (res.success) {
          message.success(`Pesonal configurations deleted successfully`);
          this.getCommonData();
          this.clickChild();
          this.resetStatesToDefault();
        }
      });
  };

  tabChange = async (val) => {
    this.setState({ tab: val });

    let name = val === '2' ? 'team_pref' : 'my_pref';
    let path = window.location.pathname;

    let obj = {
      title: this.props.skillView.view,
      url: path + `?view=${this.props.skillView.view}&tab=${name}`,
    };
    window.history.pushState(obj, obj.title, obj.url);

    if (val === '1') {
      let UserID = localStorage.trooprUserId;
      this.props.getBotChannel(this.props.workspace_id, UserID).then((res) => {
        if (res.data.success) {
          this.setState({
            personalChannelId: res.data.channel.id,
            selectedMember: false,
          });
          this.getCommonData(res.data.channel.id);
        }
      });
    } else {
      this.setState({ personalChannelId: null });
      this.props.getUserMappingAndUsers(
        this.props.workspace_id,
        this.props.skill._id,
        false,
        '.',
        true
      );
    }
  };
  // tabChange(view, id, name) {
  //   this.setState({ view: view, id: id, name: name });
  //   let queryStringObject = queryString.stringify({
  //     view: view,
  //     id: id,
  //     name: name
  //   });
  //   const path = window.location.pathname;
  //   if (id) {
  //     const obj = {
  //       "title": view,
  //       "url": path + `?view=${view}&${name}=${id}`
  //     }
  //     window.history.pushState(obj, obj.title, obj.url);
  //   } else {
  //     const obj = {
  //       "title": view,
  //       "url": path + `?view=${view}`
  //     }
  //     window.history.pushState(obj, obj.title, obj.url);
  //   }
  // }

  resetStatesToDefault = () => {
    this.setState({ ...this.defaultState });
  };

  col_span = 24;
  anchor_classname = localStorage.getItem('dark')
    ? 'anchor-links-dark'
    : 'anchor-links';

  handleUserMappingSearch = (searchTerm) => {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.props.getUserMappingAndUsers(
        this.props.workspace_id,
        this.props.skill._id,
        false,
        searchTerm,
        true
      );
    }, 500);
  };

  render() {
    const {
      projects,
      jsd_projects,
      issues,
      skill,
      currentSkillUser,
      isFromCheckins,
      personalChannelDefault,
    } = this.props;
    const { defaultProject, selectedJsdProject } = this.state;
    const { sub_skill } = this.props.match.params;
    //  console.log("currentSkillUser====>",currentSkillUser)

    let domainName;
    let serverType;
    if (
      skill && skill.skill_metadata ? skill.skill_metadata.linked : skill.linked
    ) {
      domainName =
        skill && skill.skill_metadata
          ? skill.skill_metadata.metadata.domain_name
          : skill.metadata.domain_name;
      serverType =
        skill && skill.skill_metadata
          ? skill.skill_metadata.metadata.server_type
          : skill.metadata.server_type;
    }
    let { cardTemplates } = this.props;
    let connectedAt = '';
    if (
      currentSkillUser &&
      currentSkillUser.skill_id &&
      currentSkillUser.skill_id.linked
    ) {
      let time = currentSkillUser.updated_at;
      // connectedAt = 'on '+moment(time).format('MMM Do h:mm A Z');
      connectedAt = moment(time).format('MMM Do h:mm A Z');
    }

    let projectFound = false;
    if (defaultProject)
      projectFound = projects.find((project) => project.id == defaultProject);
    else projectFound = true;
    let jsd_projectFound = false;
    if (selectedJsdProject)
      jsd_projectFound = jsd_projects.find(
        (project) => project.projectId == selectedJsdProject
      );
    else jsd_projectFound = true;

    const isPersonalConnected =
      currentSkillUser &&
        currentSkillUser._id &&
        currentSkillUser.token_obj &&
        currentSkillUser.token_obj.type !== 'Guest'
        ? true
        : false;

    return isFromCheckins ? (
      <>
        {this.getContent({ domainName, serverType, connectedAt })}{' '}
        {this.getModals({ currentSkillUser })}{' '}
      </>
    ) : (
      <>
        <PageHeader
          title='Personal Preferences'
          style={{
            position: 'sticky',
            top: 0,
            background:
              localStorage.getItem('theme') === 'dark' ? '#000' : '#eff2f5',
            zIndex: 2,
          }}
        />

        {/* <Tabs defaultActiveKey="1"> */}

        <Layout style={{ marginLeft: 0 }}>
          <Row>
            <Col
              span={
                sub_skill === 'jira_software' ||
                  sub_skill === 'jira_service_desk'
                  ? 20
                  : 24
              }
            >
              <Content className='personal_preference'>
                <div
                  id='anchor-scroll-content' /* style={(sub_skill === 'jira_software' || sub_skill === 'jira_service_desk') ? {overflowY: 'scroll', overflowX:'hidden', height : '87vh'} : {}} */
                >
                  <Row /* className={"content_row_jira"} */
                    className='main-content-padding'
                    style={{ marginBottom: 700 }}
                  >
                    <Col span={this.col_span}>
                      {sub_skill === 'jira_reports' ? (
                        <Col
                          span={this.col_span}
                          id='account'
                        // xs={{ span: 24 }}
                        // sm={{ span: 24 }}
                        // lg={{ span: 12 }}
                        // xxl={{ span: 12 }}
                        // style={{ maxWidth: "1000px" }}
                        >
                          {this.getContent({
                            domainName,
                            serverType,
                            connectedAt,
                          })}
                          {this.getModals({ currentSkillUser })}
                        </Col>
                      ) : (
                        <>
                          <Tabs
                            activeKey={this.state.tab}
                            onChange={this.tabChange}
                          >
                            <TabPane tab='My preferences' key='1'>
                              <Col
                                span={this.col_span}
                                id='account'
                                // xs={{ span: 24 }}
                                // sm={{ span: 24 }}
                                // lg={{ span: 12 }}
                                // xxl={{ span: 12 }}
                                // style={{ maxWidth: "1000px" }}
                                style={{ width: '100%', marginBottom: '16px' }}
                              >
                                {this.getContent({
                                  domainName,
                                  serverType,
                                  connectedAt,
                                })}
                              </Col>
                            </TabPane>

                            {(this.props.match.params.sub_skill ===
                              'jira_software' ||
                              this.props.match.params.sub_skill ===
                              'jira_service_desk') &&
                              this.props.isWorkspaceAdmin &&
                              currentSkillUser &&
                              currentSkillUser._id && (
                                <TabPane tab='Team member preferences' key='2'>
                                  <Col
                                    span={24}
                                    id='select_mapped_user'
                                    // xs={{ span: 24 }}
                                    // sm={{ span: 24 }}
                                    // lg={{ span: 12 }}
                                    // xxl={{ span: 12 }}
                                    style={{
                                      width: '100%',
                                      marginBottom: '16px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div>Select User:</div>
                                      <div style={{ marginLeft: 8 }}>
                                        <Select
                                          style={{ width: 300 }}
                                          showSearch
                                          placeholder='Select a  user'
                                          optionFilterProp='children'
                                          onSearch={
                                            this.handleUserMappingSearch
                                          }
                                          filterOption={(input, option) => {
                                            // console.log(option)
                                            if (
                                              typeof option.props.children ==
                                              'string'
                                            ) {
                                              return (
                                                option.props.children
                                                  .toLowerCase()
                                                  .indexOf(
                                                    input.toLowerCase()
                                                  ) >= 0
                                              );
                                            } else {
                                              return (
                                                option.props.children[0]
                                                  .toLowerCase()
                                                  .indexOf(
                                                    input.toLowerCase()
                                                  ) >= 0
                                              );
                                            }
                                          }}
                                          // value={this.state.domain}
                                          value={
                                            this.state.selectedMember.value
                                          }
                                          onChange={(e, field) =>
                                            this.selectMember(e, field)
                                          }
                                        >
                                          {this.props.usermappings.map(
                                            (mUser) => (
                                              <Option
                                                key={
                                                  mUser.user_obj.accountId ||
                                                  mUser.user_obj.name
                                                }
                                                value={mUser.user_id.user_id.toString()}
                                              >
                                                {mUser.user_id.displayName ||
                                                  mUser.user_id.name}{' '}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      </div>
                                    </div>
                                  </Col>
                                </TabPane>
                              )}
                          </Tabs>
                        </>
                      )}

                      {(skill && skill.skill_metadata
                        ? skill.skill_metadata.linked
                        : skill.linked) &&
                        sub_skill !== 'jira_reports' &&
                        this.state.personalChannelId &&
                        ((this.state.tab === '1' && currentSkillUser.user_obj) ||
                          (this.state.tab === '2' &&
                            this.state.selectedMember)) ? (
                        <>
                          {/* {this.state.selectedMember */}
                          <Row gutter={this.props.global_row_gutter}>
                            {/* this.state.personalConnected */}
                            <Col
                              span={this.col_span}
                              id='personal_notification'
                            // xs={{ span: 24 }}
                            // sm={{ span: 24 }}
                            // lg={{ span: 12 }}
                            // xxl={{ span: 12 }}
                            // style={{ maxWidth: "1000px" }}
                            >
                              {/* {(currentSkillUser.token_obj && currentSkillUser.token_obj.type !== "Guest" ||) && */}
                              {/* https://stackoverflow.com/questions/37949981/call-child-method-from-parent */}
                              <JiraPersonalNotification
                                skill={this.props.skill}
                                skillView={this.props.skillView}
                                botChannel={this.state.personalChannelId}
                                setClick={(click) => {
                                  this.clickChild = click;
                                }}
                                // isDeleted={this.state.isDeleted}

                                sConfigMember={this.state.selectedMember.value}
                                accountId={this.state.selectedMember.key}
                                setPersonalNotifConfig={(
                                  personalNotifConfig
                                ) => {
                                  this.setState({ personalNotifConfig });
                                }}
                              />
                              {/* } */}
                            </Col>

                            {/* {this.props.match.params.sub_skill === "jira_software" && ( */}
                            {this.state.personalConnected && (
                              <>
                                <Col span={this.col_span} id='issue_defaults'>
                                  <CreationDefault
                                    subSkill={this.props.match.params.sub_skill}
                                    getCommonData={this.getCommonData}
                                    sConfigMember={
                                      this.state.selectedMember.value
                                    }
                                    accountId={this.state.selectedMember.key}
                                    botChannel={this.state.personalChannelId}
                                  />
                                </Col>

                                {this.state.tab === '1' && (
                                  <Col span={this.col_span} id='troopr_in_dm'>
                                    {' '}
                                    <MultiTaskIt
                                      skill={skill}
                                      clickChild={this.clickChild}
                                      personalChannelId={
                                        this.state.personalChannelId
                                      }
                                      setClick={(click) => {
                                        this.clickChild = click;
                                      }}
                                    />
                                  </Col>
                                )}

                                <Col span={this.col_span} id='threadsync'>
                                  <Card
                                    id='thread-sync'
                                    title='Thread Sync'
                                    key='2'
                                    extra={
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                      >
                                        <Switch
                                          checked={this.state.isThreadSync}
                                          onChange={() =>
                                            this.threadSyncToggle()
                                          }
                                        />
                                      </div>
                                    }
                                  >
                                    <Paragraph type='secondary'>
                                      {/* Allow issue cards to start a Slack thread to continuously sync with the corresponding Jira issue.
Every Jira issue can have a maximum of 5 active issue cards. Newer active cards will automatically disable thread sync in the oldest one. */}
                                      <p>
                                        Jira{' '}
                                        {sub_skill === 'jira_service_desk'
                                          ? 'ticket'
                                          : 'issue'}{' '}
                                        messages in this channel will start a
                                        thread to continuously sync 2-way with
                                        the corresponding Jira{' '}
                                        {sub_skill === 'jira_service_desk'
                                          ? 'request'
                                          : 'issue'}
                                        . New messages in this thread will be
                                        added as comments in Jira and vice
                                        versa.
                                      </p>
                                    </Paragraph>
                                  </Card>
                                </Col>

                                {sub_skill === 'jira_service_desk' && (
                                  <Col
                                    span={this.col_span}
                                    id='ticket_by_default'
                                  >
                                    <Card
                                      title='Create requests by default'
                                      key='3'
                                      extra={
                                        <div
                                          onClick={(e) => e.stopPropagation()}
                                        >
                                          <Switch
                                            checked={
                                              personalChannelDefault._id
                                                ? personalChannelDefault
                                                  .link_info
                                                  .create_tickets_by_default
                                                : false
                                            }
                                            onChange={(checked) =>
                                              this.create_tickets_by_default(
                                                checked
                                              )
                                            }
                                            disabled={
                                              personalChannelDefault._id &&
                                                personalChannelDefault.link_info
                                                  .jira_service_desk
                                                ? false
                                                : true
                                            }
                                          />
                                        </div>
                                      }
                                    >
                                      <Paragraph type='secondary'>
                                        "Task It" message action and emoji
                                        creation will default to creating
                                        helpdesk requests rather than software
                                        issues.
                                      </Paragraph>
                                      {personalChannelDefault._id &&
                                        personalChannelDefault.link_info
                                          .jira_service_desk ? (
                                        ''
                                      ) : (
                                        <Paragraph type='warning'>
                                          Set the request defaults to use this.
                                        </Paragraph>
                                      )}
                                    </Card>
                                  </Col>
                                )}
                                {/* {console.log(this.props.personalChannelDefault.link_info,project_id, this.state.personalChannelId)} */}
                                {sub_skill === 'jira_software' &&
                                  (this.state.tab == '1' ||
                                    (this.state.tab === '2' &&
                                      this.state.selectedMember)) && (
                                    <Col span={this.col_span} id='card_custom'>
                                      {this.state.personalChannelId &&
                                        this.props.commonChanneldata &&
                                        this.props.commonChanneldata.find(
                                          (cha) =>
                                            cha.channel_id ===
                                            this.state.personalChannelId
                                        ) ? (
                                        <Card
                                          title='Issue card customization'
                                          extra={
                                            <Button
                                              type='primary'
                                              onClick={() =>
                                                this.setState({
                                                  showIssueCardCustomizationModal: true,
                                                })
                                              }
                                            >
                                              Customize
                                            </Button>
                                          }
                                        >
                                          {this.state
                                            .showIssueCardCustomizationModal && (
                                              <IssueCardCustomizationInfo
                                                channel_id={
                                                  this.state.personalChannelId
                                                }
                                                isPersonalPref={true}
                                                close={() =>
                                                  this.setState({
                                                    showIssueCardCustomizationModal: false,
                                                  })
                                                }
                                                customizationIn='personal'
                                                open={
                                                  this.state
                                                    .showIssueCardCustomizationModal
                                                }
                                                isRealTimeNotification={
                                                  this.state
                                                    .personalNotifConfig &&
                                                    this.state.personalNotifConfig
                                                      .frequency === 0
                                                    ? true
                                                    : false
                                                }
                                              />
                                            )}
                                          <Text type='secondary'>
                                            Customize how Troopr will show Jira
                                            issues in Slack.
                                          </Text>
                                        </Card>
                                      ) : (
                                        <Card
                                          id='issue-card'
                                          title='Issue card customization'
                                          key='4'
                                        >
                                          <Text type='warning'>
                                            Configure Issue Defaults to
                                            customize Issue card
                                          </Text>
                                          {/* <Alert
                                    description={"Configure Issue Defaults to customize Issue card"}
                                    type='warning'
                                    style={{ textAlign: "center" }}
                                  /> */}
                                        </Card>
                                      )}
                                    </Col>
                                  )}

                                <Col span={this.col_span} id='delete_config'>
                                  <Card title='Delete Personal Configuration'>
                                    <Text type='secondary'>
                                      Delete all configurations in this channel.
                                      This change is irreversible.
                                    </Text>
                                    <br />
                                    <br />
                                    <Popconfirm
                                      title={
                                        <div>
                                          The following personal preferences
                                          will be reset. <br />
                                          1. Notification preferences
                                          <br />
                                          2. Issue Defaults
                                          <br />
                                          3. Request Defaults
                                          <br />
                                          4. Thread Sync behaviour
                                          <br />
                                          <br />
                                          This change is irreversible. Are you
                                          sure?
                                        </div>
                                      }
                                      onConfirm={() =>
                                        this.deletePersoanlConfigurations()
                                      }
                                      okText='Delete'
                                      okType='danger'
                                      placement='leftBottom'
                                    >
                                      <Button danger>
                                        Reset Personal Preferences
                                      </Button>
                                    </Popconfirm>
                                  </Card>
                                </Col>
                              </>
                            )}

                            {this.getModals({ currentSkillUser })}
                          </Row>
                        </>
                      ) : null}
                      {/* </TabPane >          */}
                    </Col>
                  </Row>
                </div>
              </Content>
            </Col>
            {(sub_skill === 'jira_software' ||
              sub_skill === 'jira_service_desk') &&
              (this.state.tab === '1' ||
                (this.state.tab === '2' && this.state.selectedMember)) && (
                <Col span={4}>
                  <Anchor
                    getContainer={() =>
                      document.getElementById('anchor-scroll-content')
                    }
                    style={{ marginRight: '16px' }}
                    targetOffset={72}
                    offsetTop={72}
                  >
                    {this.state.tab === '1' && (
                      <Link
                        href='#account'
                        className={this.anchor_classname}
                        title='My Account'
                      />
                    )}
                    {currentSkillUser.user_obj &&
                      currentSkillUser.user_obj.displayName && (
                        <Link
                          href='#personal_notification'
                          className={this.anchor_classname}
                          title='Personal Notifications'
                        />
                      )}
                    {isPersonalConnected && (
                      <>
                        {sub_skill === 'jira_software' && (
                          <Link
                            href='#issue_defaults'
                            className={this.anchor_classname}
                            title='Issue creation settings'
                          />
                        )}
                        {sub_skill === 'jira_service_desk' && (
                          <Link
                            href='#ticket_defaults'
                            className={this.anchor_classname}
                            title='Request creation settings'
                          />
                        )}
                        {this.state.tab === '1' && (
                          <Link
                            href='#troopr_in_dm'
                            className={this.anchor_classname}
                            title='Use Troopr in DM channels'
                          />
                        )}
                        <Link
                          href='#threadsync'
                          className={this.anchor_classname}
                          title='Thread Sync'
                        />
                        {sub_skill === 'jira_software' &&
                          (this.state.tab === '1' ||
                            (this.state.tab === '2' &&
                              this.state.selectedMember)) && (
                            <Link
                              href='#card_custom'
                              className={this.anchor_classname}
                              title='Issue card customization'
                            />
                          )}
                        {sub_skill === 'jira_service_desk' &&
                          this.state.tab === '1' && (
                            <Link
                              href='#ticket_by_default'
                              className={this.anchor_classname}
                              title='Create requests by default'
                            />
                          )}
                        {(sub_skill === 'jira_software' ||
                          sub_skill === 'jira_service_desk') && (
                            <Link
                              href='#delete_config'
                              className={this.anchor_classname}
                              title='Delete Personal Configuration'
                            />
                          )}
                      </>
                    )}
                  </Anchor>
                </Col>
              )}
          </Row>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // user: state.common_reducer.user,

    personalChannelDefault: state.skills.personalChannelDefault,
    currentSkillUser: state.skills.currentSkillUser,
    assistant_skills: state.skills,
    channelDefault: state.skills,
    currentSkill: state.skills.currentSkill,
    cardTemplates: state.cards.templateCards,
    isWorkspaceAdmin: state.common_reducer.isAdmin,
    team: state.skills.team,
    commonChanneldata: state.skills.commonChanneldata,
    global_row_gutter: state.common_reducer.global_row_gutter,
    usermappings: state.skills.usermappings.userMappingsWithUsers.filter(
      (u) => u.isVerified
    ),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    setDefaultChannel,
    getDefaultChannel,
    getIssues,
    getProject,
    getBotChannel,
    logOutSkillUser,
    // addUserBasicToken,
    deleteUserConfig,
    getSkillUser,
    getJiraBoards,
    deleteDefaultChannel,
    getServiceDeskProject,
    deleteChannelConfigurations,
    getCommonData,
    getUserMappingAndUsers,
  })(JiraPersonalPreference)
);
